const atomic = require('../../../git_modules/@tomandco/atomic/config/color');

/**
 * Not all colors are used to generate atomic classes
 *
 * Use named colors in SCSS files by `get` function
 * @example
 * ```css
 *   .class {
 *     color: get('namedColor.abbey');
 *   }
 * ```
 *
 * All colour variable names should come from http://chir.ag/projects/name-that-color/
 *
 */
const namedColor = {
    mineShaft: '#333333',
    rollingStone: '#7A848A',
    aluminium: '#A7A9AC',
    monza: '#D90912',
    mantis: '#88BD56',
    silverSand: '#C9CACC',
    alabaster: '#F7F7F7',
    athensGray: '#EFEFF0',
    bigStone: '#1A2A49',
    white: '#FFFFFF',
    turmeric: '#C8D146',
    alizarinCrimson: '#e31e33',
    pizazz: '#F39400',
    regentGray: '#7C8E96',
    iron: '#D5DBDB',
    riverBed: '#4D5B6A',
    limedSpruce: '#3D4E57',
    naturalGrey: '#8D8D8B',
    greyAsparagus: '#515C4F',
    acapulco: '#84B59C',
    clayAsh: '#C3CFBB',
    sage: '#94A68A',
    roseFog: '#E4B2B3',
    cherub: '#FAE1E2',
    lavenderBlush: '#FFF3F7',
    wheat: '#F6E7B2',
    citrineWhite: '#FBF5E0',
    satinLinen: '#E7E5D9',
    bizarre: '#EADCD3',
    whiteLinen: '#F9F0EA',
    delta: '#B2B1A9',
    rawSienna: '#C8754C',
    chatelle: '#B8B3BE',
    tumbleweed: '#E0B285',
    coconutCream: '#F4F8DD',
    shapeOfRed: '#EA4545',
    brickRed: '#c83043',
    rusticRed: '#550413',
    roseBud: '#FBC09B',
    gin: '#E5EFE6',
    carouselPink: '#FAE4E6'
};
exports.namedColor = namedColor;

/**
 * Thouse colors are used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .col-1 { color: #454647; }
 * ```
 */
const color = [
    // default colors from atomic
    ...atomic.color,
    // custom local colours
    { key: '1', value: namedColor.mineShaft, title: 'Mine Shaft - Text Color', group: 'Primary' },
    { key: '11', value: namedColor.rollingStone, title: 'Rolling Stone', group: 'Primary' },
    { key: '12', value: namedColor.aluminium, title: 'Aluminium', group: 'Primary' },
    //error and success
    { key: '2', value: namedColor.monza, title: 'Monza - Error Color', group: 'Error' },
    { key: '3', value: namedColor.mantis, title: 'Mantis - Success Color', group: 'Success' },
    { key: '4', value: namedColor.silverSand, title: 'Silver Sand - Border Color', group: 'Lines & Borders' },
    { key: '5', value: namedColor.athensGray, title: 'Athens Gray - Background Color', group: 'Backgrounds' },
    { key: '51', value: namedColor.alabaster, title: 'Alabaster - Background Color', group: 'Backgrounds' },
    // brand colors
    { key: '6', value: namedColor.bigStone, title: 'Big Stone', group: 'Accent' },
    { key: 'w', value: namedColor.white, title: 'White', group: 'Accent' },
    // additional colors
    { key: '8', value: namedColor.turmeric, title: 'Turmeric', group: 'CTA' },
    { key: '79', value: namedColor.pizazz, title: 'Pizazz' },
    { key: '88', value: namedColor.alizarinCrimson, title: 'Alizarin Crimson', group: 'Error' },
    { key: '10', value: namedColor.regentGray, title: 'Regenant gray' },
    { key: '101', value: namedColor.iron, title: 'Iron' },
    { key: '102', value: namedColor.riverBed, title: 'River Bed' },
    { key: '103', value: namedColor.limedSpruce, title: 'Limed Spruce' },
    { key: '104', value: namedColor.naturalGrey, title: 'Natural Grey' },
    { key: '105', value: namedColor.greyAsparagus, title: 'Grey Asparagus' },
    { key: '106', value: namedColor.acapulco, title: 'Acapulco' },
    { key: '107', value: namedColor.clayAsh, title: 'Clay Ash' },
    { key: '108', value: namedColor.sage, title: 'Sage' },
    { key: '109', value: namedColor.roseFog, title: 'Rose Fog' },
    { key: '1010', value: namedColor.cherub, title: 'Cherub' },
    { key: '1011', value: namedColor.lavenderBlush, title: 'Lavender Blush' },
    { key: '1012', value: namedColor.wheat, title: 'Wheat' },
    { key: '1013', value: namedColor.citrineWhite, title: 'Citrine White' },
    { key: '1014', value: namedColor.satinLinen, title: 'Satin Linen' },
    { key: '1015', value: namedColor.bizarre, title: 'Bizarre' },
    { key: '1016', value: namedColor.whiteLinen, title: 'White Linen' },
    { key: '1017', value: namedColor.delta, title: 'Delta' },
    { key: '1018', value: namedColor.rawSienna, title: 'Raw Sienna' },
    { key: '1019', value: namedColor.chatelle, title: 'Chatelle' },
    { key: '1020', value: namedColor.tumbleweed, title: 'Tumbleweed' },
    { key: '1021', value: namedColor.coconutCream, title: 'Coconut Cream' },
    { key: '1022', value: namedColor.shapeOfRed, title: 'Shape of Red' },
    { key: '1023', value: namedColor.brickRed, title: 'Brick Red'},
    { key: '1024', value: namedColor.rusticRed, title: 'Rustic Red'},
    { key: '1025', value: namedColor.roseBud, title: 'Rose Bud'},
    { key: '1026', value: namedColor.gin, title: 'Gin'},
    { key: '1027', value: namedColor.carouselPink, title: 'Carousel Pink'}
];
exports.color = color;
